module.exports = __webpack_public_path__ + "img/npro.5a82459c.png";